export default __webpack_public_path__ + "static/media/libra_logo1.7aa2c027.png";